document.addEventListener("DOMContentLoaded", () => {
    const checkboxes = document.querySelectorAll(".custom-checkbox");
    if (!checkboxes.length) {
        return;
    }

    /** @type String[] */
    let selectedIds = [];
    let checkedInputs = JSON.parse(sessionStorage.getItem("checkedInputs"));

    if (checkedInputs) {
        selectedIds = checkedInputs;
        selectedIds.forEach((selectedId) => {
            document.querySelectorAll(".check_".concat(selectedId)).forEach((el) => {
                el.classList.add("checked");
            });
        });

        checkboxes.forEach((checkbox) => {
            const checkId = checkbox.querySelector("input").getAttribute("data-checkbox");
            selectedIds.includes(checkId) && (checkbox.querySelector("input").checked = true);
        });
    }

    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("click", () => {
            const checkId = checkbox.querySelector("input").getAttribute("data-checkbox");
            document.querySelectorAll(".check_".concat(checkId)).forEach((o) => {
                if (checkbox.querySelector("input").checked) {
                    o.classList.add("checked");
                    selectedIds.push(checkId);
                } else {
                    o.classList.remove("checked");
                    selectedIds = selectedIds.filter((e) => e !== checkId);
                }
            });

            sessionStorage.setItem("checkedInputs", JSON.stringify(selectedIds));
        });
    });
});
